'use client';

import * as Switch from '@radix-ui/react-switch';
import { twJoin } from 'tailwind-merge';

import { usePageTextContent } from '@/context/pageTextContent';

export type IncludedNetworkSectionProps = {
  isIncluded: boolean;
  onChange(value: boolean): void;
};

export function IncludedNetworkSection({
  isIncluded,
  onChange,
}: IncludedNetworkSectionProps) {
  const { content } = usePageTextContent<SearchPageContent>();

  const { showNetworks, showNetworksDescription } = content;

  const onNetworkIncludedChange = (checked: boolean) => {
    onChange(checked);
  };

  return (
    <div className="flex w-full items-center justify-between bg-gray-100 px-10 py-7">
      <div className="flex flex-col">
        <p>{showNetworks}</p>
        <p className="text-sm">{showNetworksDescription}</p>
      </div>

      <Switch.Root
        className={twJoin(
          'h-5 w-9 cursor-pointer rounded-full bg-gray-200 outline-none',
          'data-[state=unchecked]:bg-zmyle-primary data-[state=checked]:bg-green-600',
        )}
        checked={isIncluded}
        onCheckedChange={onNetworkIncludedChange}
      >
        <Switch.Thumb
          className={twJoin(
            'block size-4 rounded-full bg-white shadow-lg',
            'transition-transform duration-200 will-change-transform',
            'data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-0.5',
          )}
        />
      </Switch.Root>
    </div>
  );
}
